export default {
  UI: 'dd.MM.yyyy',
  BACKEND: 'yyyy-MM-dd',
};
